import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_156_jobcard_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Jobcard",
    style: {
      // backgroundColor: "#F1F8E9",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "jobcard_add",
        columnNumber: "m1 t1 w1",
        TableName: "service_job_card",
        DisplayName: "Jobcard",
        Workflow: "service",
        DisableSubmit: true,
        SubmitActions: [
          {
            Action: "Navigate",
            Navigate: "modulev1/vehicleinsummary",
          },
        ],
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          padding: 10,
        },
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [

              {
                componentType: ComponentType.BUTTON,
                name: "Edit",
                Label: "Edit",
                BindValue: "btn_Edit",
                onPressAction: "edit",
                ScreenId: "156",
                ActionType: "Edit",
                LockBinding: true,
                Enabled: {
                  Enable: {
                    Json_Attribute: "current_state",
                    values: ["Approved", "QC Rejected"],
                  },
                  Mode: ["View"],
                },
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                ScreenId: "156",
                ActionType: "Unlock",
                LockBinding: true,
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Basic print",
                Label: "Basic print",
                BindValue: "btn_Print",
                onPressAction: "pdf",
                Settings: "Job_card_pdf",
                ActionType: "PDF",
                Enabled: {
                  Mode: ["View"],
                },
                style: {
                  backgroundColor: "var(--primary-dark)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Complete print",
                Label: "Complete print",
                BindValue: "btn_Print_jobcard",
                onPressAction: "pdf",
                Settings: "Job_card_pdf_with_rates",
                ActionType: "PDF",
                Enabled: {
                  Mode: ["View"],
                },
                style: {
                  backgroundColor: "var(--primary-dark)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Jobcard details",
            BindValue: "con_jobcard_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Job No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "txt_jobno",
                Json_Attribute: "jobcard_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "JOB_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Job date",
                PlaceHolder: "job_date",
                IsMandatory: true,
                BindValue: "txt_jobdate",
                Json_Attribute: "job_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                DefaultToday: true,
              },
              {
                IncludeLabel: true,
                Label: "Estimation No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "parentid",
                Json_Attribute: "parent_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                IsReadOnly: true,
                LookupName: "estimation_items",
                IsVerticalView: true,
              },
              {
                Label: "",
                BindValue: "veh_details",
                componentType: ComponentType.REPORT,
                IncludeLabel: true,
                Settings: "Vehicle_details",
                Parent_Field: "parentid",
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Spare parts",
            BindValue: "cont_Work_requested",
            columnNumber: "m1 t1 w1",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SUB_MODULE,
                name: "service_spare_req",
                label: "Spare parts",
                tableName: "service_spare_req",
                lookupName: "estimation_Spareparts",
                parentField: "parentid",
                BindValue: "sub_Checklist",
                childControls: [
                  {
                    IncludeLabel: false,
                    Label: "test",
                    PlaceHolder: "",
                    IsHidden: true,
                    BindValue: "est_ref_id",
                    Json_Attribute: "est_ref_id",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    inputType: InputType.TEXT,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Code",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_code",
                    Json_Attribute: "codeid",
                    componentType: ComponentType.SEARCHABLE_DROPDOWN,
                    showInSummary: false,
                    LookupName: "product_itemcode",
                    IsVerticalView: true,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Qty",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_qty",
                    Json_Attribute: "req_qty",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Rate",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_rate",
                    Json_Attribute: "rate",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                 //   ExpressionV2: "[drp_code.sale_rate]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_amount",
                    Json_Attribute: "amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_rate] * [txt_qty]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "VAT%",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_vat",
                    Json_Attribute: "vat_id",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "tax_rates",
                    IncludeNotSet: false,
                    IsVerticalView: true,
                  },
                  {
                    IncludeLabel: true,
                    Label: "VAT amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_vat_amt",
                    Json_Attribute: "vat_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Net amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_net_amt",
                    Json_Attribute: "net_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_amount] + [txt_vat_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Department",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_department",
                    Json_Attribute: "department_id",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "department",
                    IsVerticalView: true,
                  },
                ],
                FooterControls: [
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_one",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_2",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_3",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                 
                  {
                    IncludeLabel: false,
                    Label: "Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_amount",
                    Json_Attribute: "spare_amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_amount]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                   {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_4",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                 
                  {
                    IncludeLabel: false,
                    Label: "VAT Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_vat_amt",
                    Json_Attribute: "spare_vat_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_vat_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: false,
                    Label: "Net Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_net_amount",
                    Json_Attribute: "spare_net_amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_net_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                   {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_6",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_10",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_11",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                ],
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Labour /Others",
            BindValue: "cont_labour_requested",
            columnNumber: "m1 t1 w1",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SUB_MODULE,
                name: "view_jobcard_details",
                label: "Labour /Others",
                tableName: "service_labour",
                lookupName: "estimation_labour",
                parentField: "parentid",
                BindValue: "sub_labour",
                childControls: [
                  {
                    IncludeLabel: false,
                    Label: "test",
                    PlaceHolder: "",
                    IsHidden: true,
                    BindValue: "est_ref_id",
                    Json_Attribute: "est_ref_id",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    inputType: InputType.TEXT,
                  },
                  {
                    IncludeLabel: true,
                    Label: "code",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_code",
                    Json_Attribute: "codeid",
                    componentType: ComponentType.SEARCHABLE_DROPDOWN,
                    showInSummary: false,
                    LookupName: "itemcode",

                    IsVerticalView: true,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Qty",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_qty",
                    Json_Attribute: "qty",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Rate",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_rate",
                    Json_Attribute: "rate",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: false,
                  //  ExpressionV2: "[drp_code.sale_rate]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_amount",
                    Json_Attribute: "amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_rate] * [txt_qty]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "VAT%",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_vat",
                    Json_Attribute: "vat_id",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "tax_rates",
                    IncludeNotSet: false,
                    IsVerticalView: true,
                  },
                  {
                    IncludeLabel: true,
                    Label: "VAT amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_vat_amt",
                    Json_Attribute: "vat_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Net amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_net_amt",
                    Json_Attribute: "net_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_amount] +  [txt_vat_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Department",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_department",
                    Json_Attribute: "department_id",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "department",
                    IsVerticalView: true,
                  },
                ],
                FooterControls: [
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_one",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_2",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_3",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                 
                  {
                    IncludeLabel: false,
                    Label: "Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_amount",
                    Json_Attribute: "labour_amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_amount]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                   {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_4",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                 
                  {
                    IncludeLabel: false,
                    Label: "VAT Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_vat_amt",
                    Json_Attribute: "labour_vat_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_vat_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: false,
                    Label: "Net Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_net_amount",
                    Json_Attribute: "labour_net_amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_net_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                   {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_6",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_10",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_11",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                ],
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Miscellaneous",
            BindValue: "miss_requested",
            columnNumber: "m1 t1 w1",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SUB_MODULE,
                name: "estimation_miscellaneous",
                label: "Miscellaneous",
                tableName: "service_jobcard_miscellaneous",
                lookupName: "estimation_miscellaneous",
                parentField: "parentid",
                BindValue: "sub_Checklist",
                childControls: [
                  {
                    IncludeLabel: false,
                    Label: "test",
                    PlaceHolder: "",
                    IsHidden: true,
                    BindValue: "est_ref_id",
                    Json_Attribute: "est_ref_id",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    inputType: InputType.TEXT,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Item type",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_item_type",
                    Json_Attribute: "item_type",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "item_type",
                    IsVerticalView: true,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Item name",
                    IsMandatory: true,
                    BindValue: "item_name",
                    Json_Attribute: "item_name",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: true,
                    IsVerticalView: true,
                    inputType: InputType.TEXT,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Qty",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_qty",
                    Json_Attribute: "qty",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Rate",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_rate",
                    Json_Attribute: "rate",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: false,
                    //ExpressionV2: "[drp_code.sale_rate]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_amount",
                    Json_Attribute: "amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_rate] * [txt_qty]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "VAT%",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_vat",
                    Json_Attribute: "vat_id",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "tax_rates",
                    IncludeNotSet: false,
                    IsVerticalView: true,
                  },
                  {
                    IncludeLabel: true,
                    Label: "VAT amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_vat_amt",
                    Json_Attribute: "vat_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Net amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_net_amt",
                    Json_Attribute: "net_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[txt_amount] + [txt_vat_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    IncludeLabel: true,
                    Label: "Department",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "drp_department",
                    Json_Attribute: "department_id",
                    componentType: ComponentType.SELECT_DROPDOWN,
                    showInSummary: false,
                    LookupName: "department",
                    IsVerticalView: true,
                  },
                ],
                FooterControls: [
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_one",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_2",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },


                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_4",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_6",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    IncludeLabel: false,
                    Label: "Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_amount",
                    Json_Attribute: "miscellaneous_amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_amount]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_7",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    IncludeLabel: false,
                    Label: "VAT Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_vat_amt",
                    Json_Attribute: "miscellaneous_vat_amt",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_vat_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },

                  {
                    IncludeLabel: false,
                    Label: "Net Amount",
                    PlaceHolder: "",
                    IsMandatory: false,
                    BindValue: "txt_sub_net_amount",
                    Json_Attribute: "miscellaneous_net_amount",
                    componentType: ComponentType.TEXT_FIELD,
                    showInSummary: false,
                    IsReadOnly: true,
                    ExpressionV2: "[SUM:txt_net_amt]",
                    Default_Value: "0",
                    IsVerticalView: true,
                    inputType: InputType.NUMBER,
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_10",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                  {
                    componentType: ComponentType.TEXT_FIELD,
                    BindValue: "txt_11",
                    IncludeLabel: false,
                    IsReadOnly: true,
                    style: { display: "none" },
                  },
                ],
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Total Summary",
            BindValue: "cont_total_summary",
            columnNumber: "m1 t1 w3",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Gross amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "total_sub_amount",
                Json_Attribute: "total_sub_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2:
                  "[(service_spare_req).txt_sub_amount] + [(view_jobcard_details).txt_sub_amount]+[(estimation_miscellaneous).txt_sub_amount]",
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
              {
                IncludeLabel: true,
                Label: "Discount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_discount",
                Json_Attribute: "discount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                BindParent: {
                  parentid: "discount",
                },
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
              {
                IncludeLabel: true,
                Label: "Total  amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "gross_net_amount",
                Json_Attribute: "gross_net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2:
                  "[(service_spare_req).txt_sub_net_amount] + [(view_jobcard_details).txt_sub_net_amount]+[(estimation_miscellaneous).txt_sub_net_amount]- [txt_discount]",
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
            ],
          },
        ],
      },
      {
        componentType: LayoutTypes.GRID,
        columnNumber: "m1 t2 w1",
        childComponents: [
          {
            componentType: ComponentType.BUTTON,
            name: "Submit",
            Label: "Submit",
            BindValue: "btn_submit",
            onPressAction: "save",
            ScreenId: "156",
            ActionType: "Add",
            Enabled: {
              Mode: ["Edit", "Add"],
            },
            style: {
              backgroundColor: "var(--primary-green)",
            },
          },
          {
            componentType: ComponentType.BUTTON,
            name: "Cancel",
            Label: "Cancel",
            BindValue: "btn_cancel",
            onPressAction: "navigate",
            Navigate: "modulev1/vehicleinsummary",
            ActionType: "Navigate",
            style: {
              backgroundColor: "var(--secondary-gray)",
            },
          },
        ],
      },
    ],
  },
];
